<div style="padding: 15px 0px;">
    <div data-test-id="noAnswerQuestion" [innerHTML]="question.content.text | replacePatientTerm: question.content.patientTerms : patientTerm! | sanitizeHtml"></div>
</div>